export const GENERAL_QUESTION = {
  YES: 'yes',
  NO: 'no',
};
